export const getErrorMessage = (e, defaultErrorMessage) => {
  let headline = null;
  let errorMessage = '';

  if (e.responseStatus) {
    headline = e.responseStatus.errorCode;
    errorMessage = e.responseStatus.message;
  }

  //   if (e.name === 'Unauthorized') {
  //     dispatch({
  //       type: 'set_error',
  //       payload: t('errors:api:iam:login_fail'),
  //     });
  //   } else if (e.name === 'Forbidden') {
  //     dispatch({
  //       type: 'set_error',
  //       payload: t('errors:api:iam:illegal_action'),
  //     });
  //   } else if (e.name === 'UserDeactivated') {
  //     dispatch({
  //       type: 'set_error',
  //       payload: t('errors:api:iam:account_deactivated'),
  //     });
  //   } else {
  //     dispatch({
  //       type: 'set_error',
  //       payload: t('errors:unknown_error'),
  //     });
  //   }

  if (e.name) {
    // errorMessage = t(`errors:api:${e.name}`);
    errorMessage = e.name;
  }

  if (e.message) {
    errorMessage = e.message;
  }

  if (e.status) {
    headline = e.status;
  }

  return { text: errorMessage || defaultErrorMessage || 'Unknown error', options: { headline } };
};

export function manageFunctionResponse({ response, alertController }) {
  let errorMessage;
  const managedError = {
    code: 0,
    message: '',
    handled: false,
    isError: true,
  };

  if (response) {
    const parsedResponse =
      // eslint-disable-next-line no-nested-ternary
      typeof response === 'string'
        ? JSON.parse(response)
        : typeof response?.response === 'string'
          ? JSON.parse(response.response)
          : response;

    let parsedResponseBody = {};

    if (typeof parsedResponse.body === 'string') {
      parsedResponseBody = JSON.parse(parsedResponse.body);
    } else if (parsedResponse.body) {
      parsedResponseBody = parsedResponse.body;
    }

    if (parsedResponse.statusCode >= 200 && parsedResponse.statusCode <= 299) {
      return parsedResponseBody || {};
    }

    if (parsedResponse.name === 'Validation') {
      managedError.code = '400';
      managedError.message =
        parsedResponse.errors && parsedResponse.errors.length > 0
          ? parsedResponse.errors[0].message
          : null;
    }

    const tempErrorCode =
      parsedResponse.statusCode ||
      parsedResponse.code ||
      parsedResponseBody?.code;

    const tempErrorMessage =
      parsedResponse.message || parsedResponseBody?.message;

    if (tempErrorCode >= 400 && tempErrorMessage) {
      if (tempErrorMessage === 'bad_data') {
        errorMessage = 'Invalid request data';
      } else if (tempErrorMessage === 'no_user') {
        errorMessage = 'Could not authenticate user';
      }

      managedError.code = tempErrorCode;
      managedError.message = tempErrorMessage;
    }
  }

  // global error
  if (alertController && errorMessage) {
    alertController.error({ text: errorMessage });
  }

  // if not globabl error
  if (!errorMessage) {
    return managedError;
  }

  managedError.handled = true;
  return managedError;
}
